import { Media, MetricResult } from "models";
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import RedQuickColumnChart from "./RedQuickColumnChart";
import RedQuickSlider from "./RedQuickSlider";
import { useEffect, useState } from "react";
import { decipherDate } from "features/shared_components";
import { useSelector } from "react-redux";
import { get_all_media } from "features/media/media-slice";
import RedQuickDropdown from "./RedQuickDropdown";
import { useDebounce } from "./utility";

export default function MetricHashView(props: { metrics: MetricResult[] }) {
    const [value, setValue] = useState({ val: 0, lbl: 'Value A' });
    const meteredValue  = useDebounce(value, 1000);
    const [categories, setCategories] = useState(new Array(100).fill(0).map((_, i) => i % 5 === 0 ? `${i}` : ''));
    const media_list = useSelector(get_all_media);
    const [mediaIds, setMediaIds] = useState<string[]>([])
    const [cachedMediaOptions, setCachedMediaOptions] = useState<Media[]>([]);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [view, setView] = useState<MetricResult[]>([]);
    const [graph, setGraph] = useState([]);
    
    const [title, setTitle] = useState('');

    useEffect(() => {
        let sorted_metrics = [...props.metrics].sort((a, b) => {
            return decipherDate(a.created).getTime() - decipherDate(b.created).getTime();
        });
        let medias: string[] = [];
        sorted_metrics.forEach((item) => {
            if (item?.hashProperty?.media && medias.indexOf(item?.hashProperty?.media) === -1) {
                medias.push(item?.hashProperty?.media)
            }
        });
        setMediaIds(medias);
        setView(sorted_metrics.filter(x => x?.hashProperty?.media === selectedMedia));
    }, [JSON.stringify(props.metrics), selectedMedia, media_list.length]);
    useEffect(() => {
        setCachedMediaOptions(mediaIds.map(t => media_list.find(x => x.id === t)).filter(x => x));
    }, [mediaIds, media_list.length]);

    useEffect(() => {
        if (view && meteredValue && view[meteredValue?.val]) {
            let metric = view[meteredValue?.val]
            let hashValue = metric.hashValue
            let rawData = new Array(100).fill(0).map((_, i) => hashValue[i])
            let max = Math.max(...rawData);
            if (max) {
                setTitle(`${metric.keyName} ${decipherDate(metric.time).toLocaleDateString()} ${decipherDate(metric.time).toLocaleTimeString()}`)
                setGraph(rawData.map(v => v / max));
            }
        }
    }, [meteredValue])

    return <>
        <ParentSize>{({ width, height }) => <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div>
                <RedQuickDropdown value={selectedMedia} onChange={(val: string) => {
                    setSelectedMedia(val);
                }} options={cachedMediaOptions.map((cachedMediaOption) => {
                    return ({
                        value: cachedMediaOption.id,
                        title: cachedMediaOption?.name,
                        label: cachedMediaOption?.name
                    })
                })} />
            </div>
            <div>
                <RedQuickSlider title={title} relative min={0} max={view?.length || 100} step={1}
                    value={[value]}
                    onChange={(value) => {
                        setValue(value[0]);
                    }} />
            </div>
            <div>
                <RedQuickColumnChart
                    width={width}
                    height={height - 100}
                    categories={categories} series={[{
                        name: '',
                        data: graph
                    }]} />
            </div>
        </div>}</ParentSize>
    </>
}